import React from 'react'
import { useOverlayA11y } from '../hooks/useOverlayA11y'

function downloadCodes(codes: string[]) {
  const blob = new Blob([codes.join('\n') + '\n'], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'atuune-recovery-codes.txt'
  a.click()
  URL.revokeObjectURL(url)
}

/** Shown exactly once, right after enrollment or a regenerate — these are
 * the only moment the plaintext codes exist outside a bcrypt hash on the
 * server, so this modal can't be reopened later to re-display them. */
export function MfaRecoveryCodesModal({ codes, onClose }: { codes: string[]; onClose: () => void }) {
  const modalRef = useOverlayA11y(onClose)

  return (
    <div className="modal-bg">
      <div className="modal" ref={modalRef} role="dialog" aria-modal="true" aria-label="Recovery codes" tabIndex={-1}>
        <h2>Save your recovery codes</h2>
        <p style={{ fontSize: 14 }}>
          Each code can be used once to sign in if you lose access to your authenticator app. They
          won't be shown again — save them somewhere safe.
        </p>
        <div
          className="card"
          style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 14, lineHeight: 1.9, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px 16px' }}
        >
          {codes.map((c) => <div key={c}>{c}</div>)}
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <button className="btn small outline" onClick={() => downloadCodes(codes)}>Download codes</button>
          <button className="btn small" onClick={onClose}>I've saved these — done</button>
        </div>
      </div>
    </div>
  )
}
